import script from "./EmptyDataCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyDataCard.vue?vue&type=script&setup=true&lang=js"

import "./EmptyDataCard.vue?vue&type=style&index=0&id=16a9e54d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a9e54d"]])

export default __exports__